import React from 'react';
import { Box, Chip, Grid, Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import INotificationMonitoring from '../../interfaces/INotificationMonitoring';
import langAdminNotificationMonitoring from '../../langs/langAdminNotificationMonitoring';

const STATUS_COLORS: Record<string, 'default' | 'info' | 'success' | 'error' | 'warning'> = {
	planned: 'info',
	pending: 'warning',
	sent: 'success',
	received: 'success',
	bounced: 'error',
	error: 'error',
	undefined: 'error',
};

type CAdminNotificationMonitoringKpisProps = {
	monitoring: INotificationMonitoring;
};

const CAdminNotificationMonitoringKpis = (props: CAdminNotificationMonitoringKpisProps) => {
	const { monitoring } = props;
	const { t } = useTranslation();

	const kpis = [
		{ label: langAdminNotificationMonitoring.kpi_planned.tag, value: monitoring.planned },
		{ label: langAdminNotificationMonitoring.kpi_sendable_today.tag, value: monitoring.sendableToday },
		{ label: langAdminNotificationMonitoring.kpi_sent_today.tag, value: monitoring.sentToday },
		{
			label: langAdminNotificationMonitoring.kpi_errors_today.tag,
			value: monitoring.errorsToday,
			alert: monitoring.errorsToday > 0,
		},
		{ label: langAdminNotificationMonitoring.kpi_max_per_day.tag, value: monitoring.maxPerDay },
		{
			label: langAdminNotificationMonitoring.kpi_last_send.tag,
			value: monitoring.lastSendDatetime ? moment(monitoring.lastSendDatetime).format('DD/MM/YYYY HH:mm') : '-',
		},
	];

	return (
		<Box sx={{ mb: 3 }}>
			<Grid container spacing={2} alignItems="stretch">
				{kpis.map((kpi) => (
					<Grid item key={kpi.label} xs={6} sm={4} md={2}>
						<Paper sx={{ p: 2, height: '100%' }} className="admin-notification-monitoring-kpi">
							<Typography variant="h4" component="div" color={kpi.alert ? 'error' : 'primary'}>
								{kpi.value}
							</Typography>
							<Typography variant="body2">{t(kpi.label)}</Typography>
						</Paper>
					</Grid>
				))}
			</Grid>
			<Box sx={{ mt: 2, display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
				<Typography variant="body2">{t(langAdminNotificationMonitoring.status_counts.tag)} :</Typography>
				{monitoring.statusCounts.map((statusCount) => (
					<Chip
						key={statusCount.status}
						size="small"
						color={STATUS_COLORS[statusCount.status] ?? 'default'}
						label={`${statusCount.status} : ${statusCount.count}`}
					/>
				))}
			</Box>
		</Box>
	);
};

export default CAdminNotificationMonitoringKpis;
